import type { FreelancerCertificationInformationPageLocales } from '../types';

const freelancerCertificationInformationPageLocales: FreelancerCertificationInformationPageLocales =
  {
    addCertificate: 'Voeg certificaat toe',
    certificateDeleted: 'Certificaat succesvol verwijderd!',
    confirmRemoveCertificate: 'Ja, verwijder certificaat',
    continue: 'Doorgaan',
    deleteCertificateMessage:
      'Weet je zeker dat je {{certificateName}} wilt verwijderen? Mocht je een vergissing maken, dan kan je het certificaat handmatig weer toevoegen.',
    helperMessage:
      'Voeg hieronder je certificaten toe. Geen certificaten? Dan kan je deze stap overslaan.',
    removeCertificate: 'Certificaat verwijderen',
    skipStep: 'Sla stap over',
    title: 'Certificaten',
    youWantToContinue: 'Weet je zeker dat je dit document wilt verwijderen?',
  };

export default freelancerCertificationInformationPageLocales;
